import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { CmsComponentData, MediaComponent } from "@spartacus/storefront";
import { Subscription } from "rxjs";
import { KnBrCommonService } from "src/app/services/kn-br-common.service";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ContextModalComponent } from "../kn-br-outlet/context-change-modal/context-change-modal.component";

@Component({
    selector: "knbr-fast-foam",
    templateUrl: "./kn-br-fast-foam.component.html",
    styleUrls: ["./kn-br-fast-foam.component.scss"],
    imports: [MediaComponent],
})
export class KnBrFastFoamComponent implements OnInit, OnDestroy {
  componentData$ = this.component.data$;
  allSubscriptions = new Subscription();
  sanitizedHtml: any;
  imageData: any;
  overlayText: any;
  modalRef: any;
  customersDataList$: any = this.knbrCommonService.customersData$;

  constructor(
    public component: CmsComponentData<any>,
    public knbrCommonService: KnBrCommonService,
    private sanitizer: DomSanitizer,
    private KnBrCheckoutService: KnBrCheckoutService,
    private modalService: NgbModal,
    public knBrCommonService: KnBrCommonService
  ) {
    this.KnBrCheckoutService.setCheckoutFlag(false);
  }

  ngOnInit(): void {
    this.knBrCommonService.showSpinner$.next(false);
    const popupMessage = history.state?.popupMessage;
    this.allSubscriptions.add(
      this.customersDataList$.subscribe((res) => {
        if (res && res.length > 1 && popupMessage) {
          this.changeCustomerContext(res);
          history.replaceState({}, "");
        }
      })
    );

    this.allSubscriptions.add(
      this.component.data$.subscribe((data) => {
        this.imageData = data.media;
        this.overlayText = data.name;
        this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(
          data.imageMapHTML
        );
      })
    );
  }

  changeCustomerContext(soldToAccountsList?) {
    let modalInstance: any;
    this.modalRef = this.modalService.open(ContextModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
    this.modalRef.componentInstance.soldToAccountsList = soldToAccountsList;
    this.modalRef.componentInstance.selectedCustomerNumber = null;
    modalInstance = this.modalRef.componentInstance;
  }

  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe();
  }
}
